import React, { useEffect, useState } from 'react';
import { Spin, Table } from 'antd';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import moment from 'moment';
import { userMangement } from '../../redux/actions/authActions';

const BrandList = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [brandList, setBrandList] = useState({
    data: [],
  });

  const fetchBrands = () => {
    setLoading(true);
    dispatch(userMangement('list.brands'))
      .then((result) => {
        setBrandList({
          data: get(result, 'data'),
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  return (
    <div className="team-detail-container">
      <Spin spinning={loading}>
        <Table
          rowKey="id"
          dataSource={get(brandList, 'data')}
          columns={[
            {
              title: 'Brand',
              key: 'name',
              dataIndex: 'name',
            },
            {
              title: 'Allocated on',
              key: 'allocated_on',
              dataIndex: 'allocated_on',
              render: (time) => moment(time).format('DD.MM.YYYY'),
            },
          ]}
          pagination={false}
        />
      </Spin>
    </div>
  );
};

export default BrandList;
